import { ColumnInterface } from '../../common/table/Table';
import { banColumnLabel } from '../userBans/userBan';
import { humanize } from '../userDetails/userDetailsModel';

const orDash = (key: string) => (row: any) => row[key] || '—';

export const columns: Array<ColumnInterface> = [
  { label: 'Username', key: 'username', minWidth: '112px' },
  { label: 'First Name', key: 'firstName', minWidth: '120px', rowRender: orDash('firstName') },
  { label: 'Last Name', key: 'lastName', minWidth: '120px', rowRender: orDash('lastName') },
  { label: 'Phone Number', key: 'phone', minWidth: '150px', rowRender: orDash('phone') },
  { label: 'Email', key: 'email', minWidth: '220px', rowRender: orDash('email') },
  // regionCity/regionCountry, not the City/Country relations also selected by
  // the query — those are legacy and the backend backfills the region columns
  // from them, so the relations are null for anyone who did not come in through
  // the old CSV importer.
  { label: 'City', key: 'regionCity', minWidth: '130px', rowRender: orDash('regionCity') },
  { label: 'Country', key: 'regionCountry', minWidth: '140px', rowRender: orDash('regionCountry') },
  {
    label: 'Membership',
    key: 'membershipType',
    minWidth: '110px',
    rowRender: (row) => humanize(row.membershipType) || '—',
  },
  { label: 'Points', key: 'totalPoints', minWidth: '80px', textAlign: 'right' },
  {
    label: 'Referrals',
    key: 'total',
    minWidth: '90px',
    textAlign: 'right',
    sorting: (direction: string) => ({
      Referrals: {
        _count: direction,
      },
    }),
    rowRender: (row) => `${row.Referrals?.length ?? 0}`,
  },
  {
    label: 'Recommendations',
    key: 'totalRecommendations',
    minWidth: '130px',
    textAlign: 'right',
    sorting: (direction: string) => ({
      BusinessRecommendations: {
        _count: direction,
      },
    }),
    rowRender: (row) => `${row.BusinessRecommendations?.length ?? 0}`,
  },
  {
    label: 'Referred By',
    key: 'referredBy',
    minWidth: '150px',
    sorting: (direction: string) => ({
      ReferredByReferral: {
        RefferedByUser: {
          firstName: direction,
        },
      },
    }),
    rowRender: (row) =>
      `${row.ReferredByReferral?.RefferedByUser?.firstName ?? ''} ${
        row.ReferredByReferral?.RefferedByUser?.lastName ?? ''
      }`.trim() || '—',
  },
  // Banned members are still listed here — `fetchUsers` does not filter deleted
  // accounts — so this is the only thing distinguishing one from a live account.
  // Sorts as a plain boolean column, which is the backend's own field.
  {
    label: 'Banned',
    key: 'isBanned',
    minWidth: '140px',
    rowRender: (row) => banColumnLabel(row),
  },
  // { label: 'Is Email verified', key: 'isEmailVerified' },
  // { label: 'Is Phone verified', key: 'isPhoneVerified' },
];

export const sortByOptions = [
  { label: 'TotalPoints - Ascending', value: 'totalPoints asc' },
  { label: 'TotalPoints - Descending', value: 'totalPoints desc' },
];
